import React, {useRef} from 'react';
import {ScrollView, useWindowDimensions, View} from 'react-native';
import {Banner, useTheme} from 'react-native-paper';
import {useAppSelector} from '../../../store/hooks';
import EditorForm from '../editorform';
import {useQuery} from 'react-query';
import EditorVideoComponent from '../video/editorvideo';
import {EditorPlayControls} from '../video/editorplaycontrols';
import {EditorLayer, EditorProject} from '../../../types';
import {getById, getFolderContent, writeItem} from '../../../api';
import Chat from '../../contacts/chat';
import Encoderproject from '../../encoder/encoderproject';
export function MobileLayersBanner({
  projectId,
  width,
  height,
  hasSelection,
}) {
  const showConfig = useAppSelector(state => state.editor.showConfig);
  const mediaData = useQuery(
    ['projectdata', projectId],
    async () => await getById(projectId),
    {
      enabled: projectId ? true : false,
    },
  );
  const mediaRes: EditorProject = mediaData.data;
  const layersQuery = useQuery(
    ['projectLayers', projectId],
    async () => {
      const data = await getFolderContent(projectId);
      const m = await Promise.all(
        data.map(async i => {
          return {
            ...i,
            media: await getFolderContent(i?.id),
          };
        }),
      );
      return m;
    },
  );
  const layers: EditorLayer[] | undefined = layersQuery?.data;
  const video2 = useRef<JSX.IntrinsicElements['video'] | undefined>();
  return (
    <>
      {showConfig && (
        <ScrollView
          style={{
            width,
            height: height,
            display: 'flex',
            marginRight: 5,
          }}
          key={'second_container'}
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}>
          <EditorForm
            projectId={projectId}
            mediaRes={mediaRes}
            video2={video2}
            layers={layers}
            projectQuery={mediaData}
            writeItem={writeItem}
          />
        </ScrollView>
      )}
      {!showConfig && !hasSelection && (
        <View
          style={{
            width,
            height: height,
            display: 'flex',
            paddingBottom: 100,
          }}
          key={'fourth_container'}>
          <EditorVideoComponent
            video2={video2}
            projectId={projectId}
            mediaRes={mediaRes}
            layers={layers}
            height={height}
          />
          <EditorPlayControls
            mediaRes={mediaRes}
            layers={layers}
            projectId={projectId}
          />
        </View>
      )}
    </>
  );
}
